export const CANCELLED_STATUS_ID = 'CA' as const
export const PENDING_RESIGNATION_STATUS_ID = 'PR' as const
export const DECEASED_STATUS_ID = 'DC' as const
export const TERMINATED_STATUS_ID = 'T' as const
export const RESIGNED_STATUS_ID = 'R' as const

// Statuses excluded from the Consultant Corner report dashboard (grid, leaderboard,
// and filter dropdowns) so it shows valid, active consultants only.
export const REPORT_EXCLUDED_STATUS_IDS = [
  CANCELLED_STATUS_ID,
  PENDING_RESIGNATION_STATUS_ID,
  DECEASED_STATUS_ID,
  TERMINATED_STATUS_ID,
  RESIGNED_STATUS_ID,
] as const
